module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_CertificateDocument1_16"],"path":[{"$":{"d":"M8,5H4V4H8ZM6.63,8H4V9H6.05A6,6,0,0,1,6.63,8ZM9.11,6H4V7H7.54A6,6,0,0,1,9.11,6ZM6.05,14H2V2H8.3L12,5v.56a6,6,0,0,1,2,.53V4L9,0H0V16H7.54A6,6,0,0,1,6.05,14ZM16,11.5A4.5,4.5,0,1,1,11.5,7,4.49,4.49,0,0,1,16,11.5Zm-1-1.44L14,9,10.6,12.3,9,10.76,8,11.82l2.59,2.56Z","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_CertificateDocument1_16.svg
// module id = 8IfV
// module chunks = 1